export default __webpack_public_path__ + "static/media/ep6TN4.05c1b1f3.jpg";